export enum SortOptionEnum {
  PRICE_ASC = 'PriceAsc',
  PRICE_DESC = 'PriceDesc',
  NEWEST = 'Newest',
  OLDEST = 'Oldest',
}

export enum MarketPlaceSpecimenTagEnum {

  FROZEN_BY_RSG = 3,
}
